// extracted by mini-css-extract-plugin
module.exports = {"box":"TomniSbkwI-Q0ZxkNIXdd","preview":"_1C_Q_SQV7reJKioyp2gnKG","manage":"_2Ps_pssiNA5DjpXgAV9ga1"};